import React, { Component } from 'react'
import styled from 'styled-components'
import draggable from '../Draggable'

const Icon = styled.div.attrs(props => ({
    legacy: props.legacy,
}))`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${props => (props.legacy ? '5px' : '10px 5px')};

    svg {
        width: 100%;
    }
`

class Item extends Component {
    render() {
        const { plugin, insert } = this.props

        if (!plugin.IconComponent && !plugin.text) {
            return null
        }

        const Draggable = draggable(plugin.name)

        return (
            <div className="content-editor__block">
                <div className="content-editor__block--icon">
                    <Draggable insert={insert}>
                        <Icon legacy={plugin.config.legacy}>{plugin.IconComponent}</Icon>
                    </Draggable>
                </div>
                <div className="content-editor__block--name">{plugin.text}</div>
            </div>
        )
    }
}

export default Item
